const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://demo.wgi-it.com:3001/api/v1/";

export default API_BASE_URL;
